import { styled } from '@mui/material/styles';
import VoiceLeaderboardBg from '@src/assets/images/firework-bg.svg';
import { COLOR } from '@src/styles/color';
import { Box, IconButton, Skeleton, Typography } from '@mui/material';
import { BREAKPOINTS } from '@src/styles/config';

const StyledVoiceLeaderboardContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-width: 1280px;
  padding: 0px 40px 0px 40px;
  margin: 0 auto;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: -214px;
    left: 0;
    width: 100%;
    height: 500px;
    background-image: url(${VoiceLeaderboardBg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    z-index: 0;
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;

const StyledHeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  padding-top: 64px;
  width: 100%;
  max-width: 1228px;
  margin: 0 auto;
  margin-bottom: 24px;
  @media (max-width: ${BREAKPOINTS.LMD}px) {
    .text-period-switcher,
    .text-tabs {
      font-size: 14px;
    }
    .text-back-button,
    .text-previous-event-button {
      font-size: 14px;
    }
    .tabs-description {
      width: max-content;
    }
  }
`;

const StyledPeriodSwitcher = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const StyledHeaderContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;

  @media (max-width: ${BREAKPOINTS.LMD}px) {
    .leaderboard-title {
      width: max-content;
      font-size: 40px;
    }
  }
`;

const StyledTabs = styled('div')`
  display: flex;
  background-color: ${COLOR.backgroundDefault};
  border-radius: 12px;
  padding: 4px;
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${COLOR.borderDropdown};
`;

const StyledTabItem = styled('div')`
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  background-color: ${({ isActive }) =>
    isActive ? COLOR.white : 'transparent'};
  box-sizing: border-box;
  height: 40px;
  align-items: center;
  box-shadow: ${({ isActive }) =>
    isActive && `0px 2px 16px 0px ${COLOR.boxShadow}`};
`;

const StyledPodium = styled('div')`
  display: flex;
  justify-content: center;
  gap: 24px;
`;

const StyledPodiumItem = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 576px;
  @media (max-width: ${BREAKPOINTS.LG}px) {
    .name-voice {
      font-size: 16px;
    }
  }
`;

const StyledFrame = styled('div')`
  position: relative;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  min-width: 120px;
  height: 150px;
  min-height: 120px;
`;

const StyledFrameImg = styled('img')`
  width: 150px;
  min-width: 120px;
  height: 150px;
  min-height: 120px;
  display: block;
  border-radius: 50%;
  z-index: 10;
  cursor: ${({ cursor }) => cursor || 'default'};
`;

const StyledVoiceImg = styled('img')`
  position: absolute;
  top: 44%;
  left: 50%;
  width: 102px;
  height: 102px;
  object-fit: cover;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0 2px 8px ${COLOR.boxShadow};
  z-index: 2;
`;

const StyledSkeletonFrameImg = styled(Skeleton)`
  position: absolute;
  top: 44%;
  left: 50%;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

const StyledOverlayBox = styled(Box)`
  position: absolute;
  top: 44%;
  left: 50%;
  background-color: ${COLOR.black[64]};
  border-radius: 50%;
  width: 102px;
  height: 102px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  z-index: 3;
  cursor: pointer;
  pointer-events: auto;
`;

const StyledPodiumImg = styled('img')`
  width: 100%;
  object-fit: cover;
  margin-top: 16px;
  max-width: 353px;
  height: auto;
  position: relative;
  user-select: none;
`;

const StyledVoiceDataInfo = styled('div')`
  position: absolute;
  top: 17%;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%);
`;

const StyledCreditConverter = styled('div')`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  flex-direction: column;
  background-color: ${COLOR.white};
  border: 1px solid ${COLOR.borderDropdown};
  border-radius: 12px;

  @media (max-width: ${BREAKPOINTS.MMD}px) {
    padding: 4px 8px;
  }
`;

const StyledVoiceDataInfoItemColumn = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: ${({ marginTop }) => marginTop || 0}px;
  margin-right: auto;
  margin-left: auto;
  width: max-content;
`;

const StyledVoiceDataInfoItemRow = styled('div')`
  display: flex;
  gap: 4px;
  flex-direction: column;
  margin-top: ${({ marginTop }) => marginTop || 0}px;
  width: max-content;
`;

const StyledActionsVoice = styled('div')`
  display: flex;
  gap: 4px;
  margin-top: ${({ marginTop }) => marginTop || 0}px;
  align-items: center;
  position: absolute;
  top: 60%;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%);
  @media (max-width: ${BREAKPOINTS.MD}px) {
    top: 70%;
  }
`;

const StyledRankNumber = styled('div')`
  font-size: 32px;
  font-weight: 900;
  text-align: center;
  color: ${COLOR.colorGrayV2};
  font-style: italic;
  width: 48px;
  /* margin-right: 16px; */
  max-width: 48px;
`;

const StyledDivider = styled('div')`
  display: flex;
  width: 100%;
  margin: 40px 0px;
  border: none;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(30, 22, 78, 0.16) 50%,
    rgba(255, 255, 255, 0) 100%
  );
`;

const RewardContainer = styled('div')(() => ({
  borderRadius: '16px',
  padding: '32px',
  width: '100%',
  boxShadow: '0px 4px 16px 0px #00000014',
  boxSizing: 'border-box',
  flex: 1,
}));

const RulesContainer = styled('div')`
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  box-shadow: 0px 4px 16px 0px #00000014;
  flex: 1;
  box-sizing: border-box;
  .rules-text ol {
    padding-left: 20px;
    margin: 0;
    li {
      margin-bottom: 4px;
    }
  }
`;

const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 16,
});

const Table = styled(Box)({
  width: '100%',
  borderRadius: 12,
  border: '1px solid #1E164E29',
  overflow: 'hidden',
  background: '#F7F8FA',
});

const TableRow = styled(Box)(({ header, height }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 24px',
  background: header ? '#F4F5F7' : '#fff',
  height,
  boxSizing: 'border-box',
}));

const TableCell = styled(Box)(({ width }) => ({
  flex: width ? `0 0 ${width}` : 1,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
}));

const RankNumber = styled(Typography)(({ background }) => ({
  fontWeight: 900,
  fontSize: 24,
  fontStyle: 'italic',
  width: 24,
  height: 24,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  letterSpacing: '-0.4px',
  background,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  textFillColor: 'transparent',
}));

const RewardIcon = styled('img')({
  width: 40,
  height: 40,
});

const StyledRewardContainer = styled('div')`
  display: flex;
  align-items: stretch;
  gap: 24px;
  padding: 0px 28px 40px 28px;
  max-width: 1228px;
  margin: 0 auto;
  flex: 1;

  @media (max-width: ${BREAKPOINTS.LMD}px) {
    flex-direction: column;
  }
`;

const StyledButtonLeaderboard = styled(IconButton)`
  ${({ styles }) => ({
    borderRadius: 0,
    padding: 0,
    '&:hover': {
      background: 'transparent',
    },
    animation: 'zoomInOut 1s infinite ease-in-out',
    objectFit: 'cover',
    '@keyframes zoomInOut': {
      '0%': {
        transform: 'scale(1.1)',
      },
      '50%': {
        transform: 'scale(1.05)',
      },
      '100%': {
        transform: 'scale(1.1)',
      },
    },
    ...styles,
  })}
`;

const StyledMobileWebContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70dvh;
  padding: 24px 8px;
  gap: 24px;

  .icon-mobile-web {
    height: 100px;
    width: 148.13px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .button-copy-url {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${COLOR.darkBlue};
    background-color: ${COLOR.yellow.default};
    border-radius: 12px;
    height: 48px;
    width: 100%;
  }

  .copy-icon {
    color: ${COLOR.darkBlue};
    width: 24px;
    height: 24px;
  }

  .checked-icon {
    border-radius: 50%;
    background-color: ${COLOR.darkBlue};
    color: ${COLOR.yellow.default};
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .noti-mobile {
    word-wrap: break-word;
    text-align: center;
  }

  .download-app-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .download-app {
      display: flex;
      gap: 8px;
      align-items: center;

      .qr-code {
        width: 160px;
      }

      .download-button-container {
        display: flex;
        flex-direction: column;
        gap: 14px;
      }

      .download-button {
        padding: 0;
      }
    }
  }
`;

export {
  StyledVoiceLeaderboardContainer,
  StyledHeaderContainer,
  StyledPeriodSwitcher,
  StyledHeaderContent,
  StyledTabs,
  StyledTabItem,
  StyledPodium,
  StyledPodiumItem,
  StyledFrame,
  StyledFrameImg,
  StyledVoiceImg,
  StyledOverlayBox,
  StyledPodiumImg,
  StyledVoiceDataInfo,
  StyledCreditConverter,
  StyledVoiceDataInfoItemColumn,
  StyledVoiceDataInfoItemRow,
  StyledActionsVoice,
  StyledRankNumber,
  StyledDivider,
  RewardContainer,
  HeaderRow,
  Table,
  TableRow,
  TableCell,
  RankNumber,
  RewardIcon,
  StyledRewardContainer,
  StyledButtonLeaderboard,
  StyledMobileWebContainer,
  StyledSkeletonFrameImg,
  RulesContainer,
};
